import { FontAwesome } from '@expo/vector-icons';
import React, { Dispatch, SetStateAction } from 'react';
import {
  View, Text, StyleSheet, Pressable, ScrollView, TouchableOpacity,
} from 'react-native';
import Colors from '../../../../../constants/Colors';
import { templateName } from '../../../data';
import Style from '../../../../../constants/Style';

interface TemplateDropdownProps {
  templateDropdownShown: boolean,
  setTemplateDropdownShown: Dispatch<SetStateAction<boolean>>,
  templates,
  setSelectedTemplateId: Dispatch<SetStateAction<string>>,
  selectedTemplateId: string,
  closeOtherDropdowns: () => void,
}

const TemplateDropdown = ({
  templateDropdownShown, setTemplateDropdownShown, templates,
  setSelectedTemplateId, selectedTemplateId, closeOtherDropdowns,
}: TemplateDropdownProps) => <View style={styles.container}>
    <View style={styles.titleContainer}>
      <Text style={styles.filterText}>{'Template'}</Text>
    </View>
    <>
      {!templateDropdownShown && <TouchableOpacity
        style={[Style.dropdown, { zIndex: 2 }]}
        onPress={() => {
          setTemplateDropdownShown(!templateDropdownShown);
          closeOtherDropdowns();
        }}
      >
        <View style={styles.templateNameContainer}>
          <>
            {selectedTemplateId?.length > 0 ? <Text
              numberOfLines={1}
              style={[styles.chooseAssigneeText, { color: 'black', marginEnd: 26 }]}
            >
              {templateName(selectedTemplateId, templates)}
            </Text> : <Text style={styles.chooseAssigneeText}>{'Choose Template'}</Text>}
            <View style={{ flex: 1, alignItems: 'flex-end' }}>
              <FontAwesome
                size={20}
                style={styles.icon}
                name={'angle-down'}
              />
            </View>
          </>
        </View>
      </TouchableOpacity>}
      {templateDropdownShown && <View style={[Style.dropdown, { zIndex: 2 }]}>
        <TouchableOpacity
          style={{ flex: 1, alignItems: 'flex-end' }}
          onPress={() => {
            setTemplateDropdownShown(false);
            closeOtherDropdowns();
          }}
        >
          <FontAwesome
            size={20}
            style={{ color: Colors.light.hereworksLightBlue, marginEnd: 12 }}
            name={'angle-up'}
          />
        </TouchableOpacity>
      </View>}
    </>
    {templateDropdownShown && <ScrollView
      style={styles.dropdownView}
      nestedScrollEnabled
    >
      <Pressable
        onPress={() => {
          setSelectedTemplateId('');
          setTemplateDropdownShown(false);
          closeOtherDropdowns();
        }}
        style={(state) => [
          styles.button,
          { backgroundColor: state.hovered ? Colors.light.hereworksWhite200 : undefined },
        ]}
      >
        <Text style={styles.filterText}>{'ALL TEMPLATES'}</Text>
      </Pressable>
      {templates.map((template: any, key) => (<Pressable
          key={key}
          onPress={() => {
            setSelectedTemplateId(template.id);
            setTemplateDropdownShown(false);
            closeOtherDropdowns();
          }}
          style={(state) => [
            styles.button,
            { backgroundColor: state.hovered ? Colors.light.hereworksWhite200 : undefined },
            selectedTemplateId === template.id && styles.selected,
          ]}
        >
        <Text style={styles.filterText}>{template.name}</Text>
      </Pressable>))}
    </ScrollView>}
  </View>;

const styles = StyleSheet.create({
  container: {
    marginTop: 13,
  },
  titleContainer: {
    height: 36,
    justifyContent: 'center',
  },
  templateNameContainer: {
    flexDirection: 'row',
    flex: 2,
    alignItems: 'center',
  },
  chooseAssigneeText: {
    color: Colors.light.hereworksPrimaryGrey800,
    fontFamily: 'Poppins_400Regular',
    fontSize: 14,
    marginStart: 10,
  },
  dropdownView: {
    width: '100%',
    maxHeight: 200,
    backgroundColor: '#fff',
    borderWidth: 1.5,
    borderColor: Colors.light.hereworksBlue100,
    borderRadius: 10,
    marginTop: 4,
  },
  button: {
    paddingStart: 10,
    paddingVertical: 10,
    borderRadius: 4,
    marginVertical: 4,
  },
  filterText: {
    fontFamily: 'Roboto_400Regular',
    fontSize: 14,
    lineHeight: 18,
    marginBottom: 4,
    marginEnd: 20,
    color: Colors.light.hereworksBlack600,
  },
  selected: {
    borderColor: Colors.light.hereworksBlue400,
    borderWidth: 1,
  },
  icon: {
    color: Colors.light.hereworksBlue500,
    marginEnd: 12,
  },
});

export default TemplateDropdown;
